import styled from 'styled-components';
import { isWithBackground } from './utils';
export const TitleContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  width: ${({ stylingType }) => isWithBackground(stylingType) ? 'calc(100% - 3.5rem);' : 'calc(100% - 2.5rem);'};
`;
